import { deserialize, deserializeArray, serialize } from 'class-transformer'
import { Event } from '../model/Event'
import { ConfigStore } from '../model/Store/ConfigStore'

const STORAGE_CONFIG_KEY = 'config'
const STORAGE_STATE_KEY = 'events'

export const loadConfigState = (): ConfigStore|undefined => {
  try {
    const serializedState = localStorage.getItem(STORAGE_CONFIG_KEY)
    if (!serializedState) {
      return undefined
    }

    return deserialize(ConfigStore, serializedState)
  } catch (e) {
    return undefined
  }
}

export const saveConfigState = (state: ConfigStore): void => {
  try {
    const serializedState = serialize(state)
    localStorage.setItem(STORAGE_CONFIG_KEY, serializedState)
  } catch (e) {
    // Ignore write errors.
  }
}

export const loadEventsState = (): Event[]|undefined => {
  try {
    const serializedState = localStorage.getItem(STORAGE_STATE_KEY)
    if (!serializedState) {
      return undefined
    }

    return deserializeArray(Event, serializedState)
  } catch (e) {
    return undefined
  }
}

export const saveEventsState = (state: Event[]): void => {
  try {
    const serializedState = serialize(state)
    localStorage.setItem(STORAGE_STATE_KEY, serializedState)
  } catch (e) {
    // Ignore write errors.
  }
}
